import React from 'react';
import { cn } from '@/lib/cn';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div aria-hidden className={cn('oi-skeleton', 'rounded-lg', className)} {...props} />;
}

export default Skeleton;
